import * as formatters from "@ppb/formatters";

type Currency = Omit<formatters.Currency, "currencyCode"> & {
  currencyCode: string | null;
};

export const currencyFormatWithDecimalPlaces = ({ currencyCode, ...rest }: Currency): string =>
  currencyCode ? formatters.currencyFormatWithDecimalPlaces({ ...rest, currencyCode }) : "";

export const currencyFormatWithoutDecimalPlaces = ({ currencyCode, ...rest }: Currency): string =>
  currencyCode ? formatters.currencyFormatWithoutDecimalPlaces({ ...rest, currencyCode }) : "";
